/**
 * elopementRisk.js
 *
 * @description Dismiss Elopement Risks
 */

import { SVC_B } from './base.js'
import queryString from 'query-string'

/**
 * Dismiss a given alert, by UUID, secured with a pin.
 *
 * @export
 * @param {String} uuid The UUID of the alert to dismiss.
 * @param {String} pin The PIN of the user performing the dismissal.
 */
export function dismissAlertWithPin (alertId, userPIN) {
  return SVC_B.post(`/api/v1/faces/alerts/${alertId}/dismiss`, { userPIN })
}

/**
 * Fetches the events in the domain.
 *
 * @export
 * @param {string} domainUUID The domain to fetch against
 * @param {string} since A timestamp defining the earliest possible event.
 * @param {string} before A timestamp defining the latest possible event.
 * @param {number} offset A SQL offset
 * @param {number} limit A SQL limit
 * @param {string} sort Either 'ascending' or 'descending'. If no value or an invalid value, `ASC` is used.
 * @param {boolean} dismissed Include dismissed?
 * @returns
 */
export function fetchFacesAlerts ({
  domainUUID,
  since,
  before,
  offset,
  limit,
  sort,
  includeDismissed,
} = {}) {
  const query = queryString.stringify({
    domainUUID,
    since,
    before,
    offset,
    limit,
    sort,
    include_dismissed: includeDismissed,
  })
  return SVC_B.get(`/api/v1/faces/alerts?`, query)
}
